const firebaseConfig = {
    apiKey: "AIzaSyAoWJGCXG9WaPuarkXhKWcYpT4GIcrAQfc",
    authDomain: "physical-therapy-8f3a8.firebaseapp.com",
    projectId: "physical-therapy-8f3a8",
    storageBucket: "physical-therapy-8f3a8.appspot.com",
    messagingSenderId: "340295739480",
    appId: "1:340295739480:web:bb441fa90970f46869422d"
  };
  export default firebaseConfig ;